import { render } from "./CompareTablePivot.vue?vue&type=template&id=1aceba2b&scoped=true&ts=true"
import script from "./CompareTablePivot.vue?vue&type=script&lang=ts"
export * from "./CompareTablePivot.vue?vue&type=script&lang=ts"

import "./CompareTablePivot.vue?vue&type=style&index=0&id=1aceba2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aceba2b"]])

export default __exports__